export { LegalLinksComponent } from './legal-links.component';
